import { Warehouse } from "./warehouse";

import { cloneDeep, startCase } from "lodash";
import moment from "moment-timezone";

const DEFAULT_ATTRIBUTES = {
  id: "",
  from_warehouse_id: null,
  to_warehouse_id: null,
  seller_id: null,
  type: null,
  goods_in_recurrence_id: null,
  requested_from: null,
  requested_to: null,
  requested_at: null,
  confirmed_from: null,
  confirmed_to: null,
  confirmed_at: null,
  cancelled_at: null,
  received_at: null,
  to_process_at: null,
  status: null,
  stats: {
    items: null,
  },
  resource_type: "",
  package_type: "package",
  packages_count: 0,
  total_volume: null,
  driver: null,
  shipping_category: null,
};

export class GoodsIn {
  constructor(attributes) {
    const attrs = { ...cloneDeep(DEFAULT_ATTRIBUTES), ...attributes };

    Object.keys(attrs).forEach((key) => {
      this[key] = attrs[key];
    });

    if (this.to_warehouse) {
      if (!this.to_warehouse["address"]) {
        this.to_warehouse["address"] = this.to_address;
      }

      this.to_warehouse = new Warehouse(this.to_warehouse);
    }

    if (this.from_warehouse) {
      if (!this.from_warehouse["address"]) {
        this.from_warehouse["address"] = this.from_address;
      }

      this.from_warehouse = new Warehouse(this.from_warehouse);
    }
  }

  abilities = {
    edited: (loggedInUser) => this.isRequested,
  };

  //? methods related to the type of goods in.
  get isPickup() {
    return this.type === "Pickup";
  }

  get isTransfer() {
    return this.type === "Transfer";
  }

  //? methods related to the status of the goods in.
  initialStatus(loggedInUser) {
    if (
      this.requested_from &&
      this.requested_from.isSame(moment(), "day") &&
      loggedInUser.isWarehouseOwner()
    ) {
      return "confirmed";
    }

    return "requested";
  }

  get isRequested() {
    return this.status === "requested";
  }

  get isConfirmed() {
    return this.status === "confirmed"; //a recolectar
  }

  //? methods related to the service type.
  get isSameDay() {
    return this.shipping_category === "super_express";
  }

  //? methods related to the goods in dates.
  get fromHour() {
    return this.isRequested ? this.requested_from : this.confirmed_from;
  }

  get toHour() {
    return this.isRequested ? this.requested_to : this.confirmed_to;
  }

  //? methods related to the goods in addresses.
  get fromWarehouseAddress() {
    if (!this.from_address) {
      return "";
    }
    return this.from_address.line
      ? `${this.from_address.line}, ${this.fromAddressRegion}`
      : `${this.from_address.street_name} ${this.from_address.street_number}, ${this.fromAddressRegion}`;
  }

  get fromAddressRegion() {
    if (this.from_address.state === this.from_address.city) {
      return `${startCase(this.from_address.city.toLowerCase())}`;
    }
    return `${startCase(this.from_address.city.toLowerCase())}, ${startCase(
      this.from_address.state.toLowerCase()
    )}`;
  }

  canBe(action, loggedInUser) {
    if (this.abilities.hasOwnProperty(action)) {
      return this.abilities[action](loggedInUser);
    }
    return true;
  }
}
